import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserMenu from './UserMenu';
import NotificationBell from './Notifications/NotificationBell';
import styles from './Header.module.css';

// Cloudinary hosted logo
const logo = 'https://res.cloudinary.com/dqushvncg/image/upload/v1765434267/logo_zvkjeg.png';

const Header = ({ user, userProfile }) => {
  const navigate = useNavigate();
  
  // Get first name for greeting
  const firstName = userProfile?.firstName;

  return (
    <header className={styles.header}>
      <div className={styles.logoSection} onClick={() => navigate('/')}>
        <img src={logo} alt="App Logo" className={styles.logo} />
        <span className={styles.appName}>Sport Loop</span>
      </div>
      
      {/* Center Greeting */}
      {user && firstName && (
        <div className={styles.greeting}>
          Welcome back, <span className={styles.userName}>{firstName}</span>!
        </div>
      )}
      
      {/* Header Actions - Notification Bell + User Menu */}
      <div className={styles.headerActions}>
        {user && <NotificationBell />}
        <UserMenu user={user} />
      </div>
    </header>
  );
};

export default Header;
